import { useMemo } from 'react'
import { SocketStyles, SocketLabels, SocketRoles } from '../utils/constants'
import { getTeacherInfo, categorizeStudents } from '../utils/socketHelpers'

export const useOrderedSockets = (sockets = []) => {
  return useMemo(() => {
    const studentWithoutTeacher = sockets.filter(socket => {
      if (socket.role === SocketRoles.STUDENT && !socket.classroom?.teacher) {
        socket.customStyle = SocketStyles.WAITING_ROOM
        socket.customInfo = SocketLabels.WAITING_ROOM
        return socket
      }
    })
    const studentsInBackground = sockets.filter(socket => {
      if (socket.role === SocketRoles.STUDENT) {
        const teacher = sockets.find(
          ({ _id }) => socket.classroom?.teacher === _id
        )
        if (!teacher) return
        if (!teacher.classroom?.students?.includes(socket._id)) {
          socket.customStyle = SocketStyles.NEEDS_ATTENTION
          socket.customInfo = SocketLabels.NEEDS_ATTENTION
          return socket
        }
      }
    })
    const teacherWithStudentsInOrder = sockets.reduce((acc = [], socket) => {
      if (socket.role === SocketRoles.TEACHER) {
        socket.customInfo = getTeacherInfo(socket)
        socket.classroom.students.forEach(studentId => {
          if (studentWithoutTeacher.map(({ _id }) => _id).includes(studentId)) {
            socket.customStyle = SocketStyles.WARNING
            return
          }
          if (!sockets.find(s => s._id === studentId))
            socket.customStyle = SocketStyles.WARNING
        })
        acc.push(socket)
        const studentIds = socket.classroom?.students
        if (studentIds.length > 0) {
          const connectedStudents = sockets.filter(
            s =>
              studentIds.includes(s._id) && s.classroom?.teacher === socket._id
          )
          const { trainees, leads, others } =
            categorizeStudents(connectedStudents)
          acc.push(...trainees.concat(leads).concat(others))
        }
      }
      return acc
    }, [])

    return studentsInBackground
      .concat(studentWithoutTeacher)
      .concat(teacherWithStudentsInOrder)
  }, [sockets])
}
